import * as React from "react";

function CloseIcon(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 12 12"
			width="1em"
			height="1em"
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M4.28 3.22a.75.75 0 0 0-1.06 1.06L4.94 6L3.22 7.72a.75.75 0 0 0 1.06 1.06L6 7.06l1.72 1.72a.75.75 0 0 0 1.06-1.06L7.06 6l1.72-1.72a.75.75 0 0 0-1.06-1.06L6 4.94z"
				clipRule="evenodd"
			></path>
		</svg>
	);
}

export default CloseIcon;
